const storageKeyHodnoceni = "storeRatingData-" + document.location.host;

function generateStars(score) {
  const full = Math.floor(score);
  const half = score % 1 >= 0.5;
  let html = "";

  for (let i = 0; i < full; i++) {
    html += '<span class="star star-on"></span>';
  }
  if (half && full < 5) {
    html += '<span class="star star-half"></span>';
  }
  return html;
}
function renderRating(data) {
    let d;

    try {
        d = typeof data === "string" ? JSON.parse(data) : data;
    } catch (e) {
        return;
    }

    const count = d.count || 0;
    const percentRating = (d.averageScore / 5) * 100 || 0;
    const ratings = d.ratings?.slice(0, 3) || [];

    $(".heureka .h1").text(percentRating.toFixed(0) + "%");
    $(".heureka .h2").text(percentRating.toFixed(0) + "%");

    const reviewHtml = ratings
        .filter((r) => (parseFloat(r.score) || 0) > 4)
        .map((r) => {
            const date = formatAddedDate(r.created.date);

            return `
                <div class="review-item">
                    <div class="stars">${generateStars(parseFloat(r.score) || 0)}</div>
                    <div class="description">${r.description}</div>
                    <div class="info">
                        <div class="name">${r.fullName || "Ověřený zákazník"}</div>
                        <div class="date">${date}</div>
                    </div>
                </div>
            `;
        })
        .join("");

    $(".reviews").html(reviewHtml);
}

const stored = sessionStorage.getItem(storageKeyHodnoceni);
if (stored) {
  renderRating(JSON.parse(stored));
} else {
  $.ajax({
    url: "/cache/hodnoceni-obchodu/?jsonFormat",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Store-Rating-Details": "true",
    },
    success: function (response) {
      sessionStorage.setItem(storageKeyHodnoceni, JSON.stringify(response));
      renderRating(response);
    },
    error: function (xhr, status, error) {
      console.error("Chyba při načítání hodnocení:", error);
    },
  });
}

function formatAddedDate(dateString) {
  const inputDate = new Date(dateString.replace(" ", "T"));
  const now = new Date();

  const diffMs = now - inputDate;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);

  // méně než týden
  if (diffDays < 7) {
    if (diffDays <= 1) return "Přidáno dnes";
    return `Přidáno před ${diffDays} dny`;
  }

  // méně než měsíc (~30 dní)
  if (diffDays < 30) {
    if (diffWeeks === 1) return "Přidáno před týdnem";
    if (diffWeeks >= 2 && diffWeeks <= 4) {
      return `Přidáno před ${diffWeeks} týdny`;
    }
  }

  // starší než měsíc → konkrétní datum
  return (
    "Přidáno " +
    inputDate.toLocaleDateString("cs-CZ", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
  );
}

moveVoteStars();
function moveVoteStars() {
  if ($("#ratingsList .vote-wrap").length) {
    $("#ratingsList .vote-wrap").each(function () {
      var $vote = $(this);
      if (!$vote.find(">.stars").length) {
        $vote.find(".stars").clone().prependTo($vote);
      }
    });
  }
}

document.addEventListener("ShoptetDOMProductRatingsLoaded", function () {
  moveVoteStars();
});
